import React from "react";
import Header from "../../components/header";
import zForHerHero from "../../images/zforher-hero.png";

const ZForHerMain = () => {
  return (
    <>
      <Header />
      <section
        style={{ marginTop: "-88px" }}
        className="relative w-full overflow-hidden min-h-[1024px] sm:min-h-[100vh]"
      >
        <img
          src={zForHerHero}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />

        <div
          className="relative z-10 flex flex-col items-center justify-center w-full min-h-[1024px] sm:min-h-[100vh]"
          style={{
            paddingTop: "clamp(112px, 11.11vw, 160px)",
            paddingBottom: "clamp(48px, 5.56vw, 96px)",
            paddingLeft: "clamp(20px, 5.56vw, 80px)",
            paddingRight: "clamp(20px, 5.56vw, 80px)",
          }}
        >
          <div className="flex flex-col items-center gap-12 sm:gap-8 text-center max-w-[753px]">
            <div className="flex flex-col items-center gap-6 sm:gap-4">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#86C7A8",
                    flexShrink: 0,
                    display: "inline-block",
                  }}
                />
                <span
                  style={{
                    fontFamily: "'Geist Mono', monospace",
                    fontWeight: 500,
                    fontSize: "12px",
                    lineHeight: 1,
                    letterSpacing: "0.1em",
                    color: "#86C7A8",
                    textTransform: "uppercase",
                  }}
                >
                  Z-ForHer &middot; Available in Anambra
                </span>
              </div>

              <h1
                className="text-white text-[60px] leading-tight sm:text-[36px]"
                style={{ fontFamily: "'Instrument Serif', serif" }}
              >
                Flexible funding for{" "}
                <span
                  className="italic"
                  style={{
                    fontFamily: "'Instrument Serif', serif",
                    color: "#86C7A8",
                  }}
                >
                  women
                </span>{" "}
                growing their businesses.
              </h1>
              <p
                className="text-[#F5F4F4] text-[20px] leading-[32px] max-w-[626px] sm:text-[16px] sm:leading-[26px]"
                style={{ fontFamily: "'Geist', sans-serif" }}
              >
                Built for women entrepreneurs, Z-ForHer gives you access to
                funds when you need them, so you can stock up, expand, and keep
                your business moving.
              </p>
            </div>

            <div className="flex items-center gap-3 sm:flex-col sm:w-full">
              <a
                href="https://zikoramfb.qoreonline.com/onboarding/type"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#86C7A8] text-[#132A22] rounded-lg px-4 py-4 text-[16px] leading-[20px] sm:w-full text-center"
                style={{ fontFamily: "'Geist', sans-serif", fontWeight: 600 }}
              >
                Apply for ZForHer
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.clive.zikora"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-[#DEDEDE] text-white rounded-lg px-4 py-4 text-[16px] leading-[20px] sm:w-full text-center"
                style={{ fontFamily: "'Geist', sans-serif", fontWeight: 600 }}
              >
                Download the App
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ZForHerMain;
